import React, { useState } from "react";
import { Table, Input, Button, Card ,Modal,Checkbox,Radio} from "antd";
import { useNavigate } from "react-router-dom";

const { Search } = Input;

function exportCSV(data) {
const fields = ['sno', 'fileId', 'month', 'beneficiaries', 'status', 'lastRun'];
const header = ['S.no', 'File ID', 'Month', 'Total Beneficiaries', 'Status', 'Last Run'];
const rows = data.map(row => fields.map(field => `"${row[field] || ''}"`).join(','));
  const csvContent = [header.join(','), ...rows].join('\n');
  const blob = new Blob([csvContent], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'RawMaterial_Planning.csv';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
}
const FILTERS = [
  { label: "All", value: "All" },
  { label: "Completed", value: "Completed" },
  { label: "Pending RM", value: "Pending RM" },
  { label: "Processed", value: "Processed" },
];

const data = [
  { key: "1", sno: "01", fileId: "ABC9876543", month: "MAR 2026", beneficiaries: "123456", status: "Completed", lastRun: "2026-03-20 09:15" },
  { key: "2", sno: "02", fileId: "ABC9876543", month: "MAR 2026", beneficiaries: "123456", status: "Completed", lastRun: "2026-03-20 09:15" },
  { key: "3", sno: "03", fileId: "ABC9876543", month: "MAR 2026", beneficiaries: "123456", status: "Completed", lastRun: "2026-03-20 09:15" },
  { key: "4", sno: "04", fileId: "ABC9876543", month: "MAR 2026", beneficiaries: "123456", status: "Completed", lastRun: "2026-03-20 09:15" },
  { key: "5", sno: "05", fileId: "ABC9876543", month: "MAR 2026", beneficiaries: "123456", status: "Pending RM", lastRun: "2026-03-20 09:15" },
  { key: "6", sno: "06", fileId: "ABC9876543", month: "MAR 2026", beneficiaries: "123456", status: "Processed", lastRun: "2026-03-20 09:15" },
];

const RawMaterial_Planning = () => {
  const navigate = useNavigate();
  const [filter, setFilter] = useState("All");
  const [search, setSearch] = useState("");
  

  const [showPrintModal, setShowPrintModal] = useState(false);
  const [fileName, setFileName] = useState("KTKKAR0987.AUG 2025");
  const [include, setInclude] = useState(["RM Print"]);
  const [format, setFormat] = useState("PDF");
  const [pageSize, setPageSize] = useState("A4");
  const [orientation, setOrientation] = useState("Portrait");
  const [destination, setDestination] = useState("download");

  const columns = [
    { title: "S.No", dataIndex: "sno", key: "sno" },
    { title: "File ID", dataIndex: "fileId", key: "fileId" },
    { title: "Month", dataIndex: "month", key: "month" },
    { title: "Total Beneficiaries", dataIndex: "beneficiaries", key: "beneficiaries" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 120,
      render: (status) => {
        if (status === "Completed")
          return <span style={{ background: "#eaf3fe", color: "#3585fa", borderRadius: 20, fontWeight: 500, fontSize: 13, padding: "1px 18px" }}>Completed</span>;
        if (status === "Pending RM")
          return <span style={{ background: "#e6fbf0", color: "#2aad60", borderRadius: 20, fontWeight: 500, fontSize: 13, padding: "1px 14px" }}>Pending RM</span>;
        if (status === "Processed")
          return <span style={{ background: "#f2f2fa", color: "#37bf4d", borderRadius: 20, fontWeight: 500, fontSize: 13, padding: "1px 15px" }}>Processed</span>;
        return status;
      },
    },
    { title: "Last Run", dataIndex: "lastRun", key: "lastRun", width: 130, ellipsis: true },
    {
      title: "Action",
      key: "action",
      width: 170,
      render: (_, record) => {
        if (record.status === "Pending RM") {
          return (
            <Button
              style={{
                background: "#1677ff",
                color: "#fff",
                borderRadius: 20,
                fontWeight: 600,
                minWidth: 95,
                height: 32,
                border: "none",
              }}
              size="small"
              onClick={() =>
                navigate("/master/raw-material-planning/details", { state: { record } })
              }
            >
              Calculate
            </Button>
          );
        }
        return (
          <div style={{ display: "flex", gap: 8 }}>
            <Button
              style={{ background: "#fff", color: "#313b4f", border: "1px solid #e3e5eb", borderRadius: 5, fontWeight: 500, minWidth: 75, height: 32 }}
              size="small"
              onClick={() =>
    navigate("/master/raw-material-planning/preview", { state: { record } })
  }
            >
              Preview
            </Button>
            <Button
              style={{ background: "#fff", color: "#313b4f", border: "1px solid #e3e5eb", borderRadius: 5, fontWeight: 500, minWidth: 75, height: 32 }}
              size="small"
              onClick={() => setShowPrintModal(true)}
            >
              Print File
            </Button>
          </div>
        );
      },
    },
  ];

  const filteredData = data.filter((item) => {
    const matchesFilter = filter === "All" || item.status === filter;
    const matchesSearch =
      item.fileId.toLowerCase().includes(search.toLowerCase()) ||
      item.month.toLowerCase().includes(search.toLowerCase());
    return matchesFilter && matchesSearch;
  });

  return (
    <div style={{ background: "#f8fafc", minHeight: "100vh", }}>
      <Card
        bodyStyle={{ padding: 24, background: "#fff" }}
        style={{ maxWidth: 1100, margin: "32px auto", boxShadow: "0 2px 8px #f0f1f2", borderRadius: 18 }}
      >
        {/* Export Button */}
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
          <Button  onClick={()=>exportCSV(filteredData)}style={{ background: "#fff", color: "#1a1a1a", borderRadius: 8, fontWeight: 600, fontSize: 15, border: "1px solid #d4d8de", boxShadow: "none", minWidth: 92, height: 36 }}>
            Export
          </Button>
        </div>

        {/* Search + Filters */}
        <div style={{ display: "flex", alignItems: "center", marginBottom: 12 }}>
          <Search
            placeholder="Search By Name or HSN"
            allowClear
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            style={{ width: 380, marginRight: 28 }}
            size="large"
          />
          <div style={{ display: "flex", gap: 10 }}>
            {FILTERS.map((opt) => (
              <Button
                key={opt.value}
                style={{
                  background: filter === opt.value ? "#eaf3fe" : "#fff",
                  color: filter === opt.value ? "#3585fa" : "#b0b5bd",
                  borderRadius: 20,
                  height: 36,
                  minWidth: 80,
                }}
                onClick={() => setFilter(opt.value)}
              >
                {opt.label}
              </Button>
            ))}
          </div>
        </div>

        {/* Table */}
        <Table
          columns={columns}
          dataSource={filteredData}
          pagination={false}
          bordered
          style={{ background: "#fff", borderRadius: 12 }}
          tableLayout="fixed"
          size="small"
        />
      </Card>
      {/* Print Modal */}
      <Modal
        title="Print / Export"
        open={showPrintModal}
        onCancel={() => setShowPrintModal(false)}
        footer={null}
        centered
        style={{width:"60%",backgroundColor:"rgba(128,128,128,0.6)"}}
      >
        {/* File Name */}
        <div style={{ marginBottom: 24 }}>
          <label style={{ fontWeight: 600, display: "block", marginBottom: 6 }}>
            File Name
          </label>
          <Input
            value={fileName}
            onChange={(e) => setFileName(e.target.value)}
            style={{ borderRadius: 6 }}
          />
        </div>

        {/* 1. Include */}
        <div style={{ marginBottom: 24 }}>
          <div
            style={{
              fontWeight: 600,
              paddingBottom: 6,
              borderBottom: "1px solid #eee",
              marginBottom: 10,
            }}
          >
            1. Include
          </div>
          <Checkbox.Group
            value={include}
            onChange={setInclude}
            style={{ display: "flex", flexDirection: "column", marginTop: 8 }}
          >
            <Checkbox value="RM Print">RM Print</Checkbox>
            <Checkbox value="DRMS">DRMS</Checkbox>
            <Checkbox value="PO">PO</Checkbox>
            <Checkbox value="Job Work">Job Work</Checkbox>
            <Checkbox value="Raw Material lifting quantity">
              Raw Material lifting quantity
            </Checkbox>
          </Checkbox.Group>
          <div style={{ fontSize: 12, color: "#888", marginTop: 6 }}>
            Kindly choose one option
          </div>
        </div>

        {/* 2. Output */}
        <div style={{ marginBottom: 24 }}>
          <div
            style={{
              fontWeight: 600,
              paddingBottom: 6,
              borderBottom: "1px solid #eee",
              marginBottom: 10,
            }}
          >
            2. Output
          </div>
          <div style={{ marginTop: 8 }}>
            <Radio.Group
              value={format}
              onChange={(e) => setFormat(e.target.value)}
              style={{ marginBottom: 10 }}
            >
              <Radio value="PDF">PDF</Radio>
              <Radio value="Excel">Excel</Radio>
            </Radio.Group>
          </div>

          <div>
            <Radio.Group
              value={pageSize}
              onChange={(e) => setPageSize(e.target.value)}
              style={{ marginRight: 20 }}
            >
              <Radio value="A4">A4</Radio>
              <Radio value="A3">A3</Radio>
            </Radio.Group>

            <Radio.Group
              value={orientation}
              onChange={(e) => setOrientation(e.target.value)}
            >
              <Radio value="Portrait">Portrait</Radio>
              <Radio value="Landscape">Landscape</Radio>
            </Radio.Group>
          </div>
        </div>

        {/* 3. Destination */}
        <div style={{ marginBottom: 24 }}>
          <div
            style={{
              fontWeight: 600,
              paddingBottom: 6,
              borderBottom: "1px solid #eee",
              marginBottom: 10,
            }}
          >
            3. Destination
          </div>
          <Radio.Group
            value={destination}
            onChange={(e) => setDestination(e.target.value)}
            style={{ display: "flex", flexDirection: "column", gap: 6 }}
          >
            <Radio value="download">Download file</Radio>
            <Radio value="print">Open system print dialog</Radio>
          </Radio.Group>
          <div style={{ fontSize: 12, color: "#888", marginTop: 6 }}>
            If "Open print dialog" is chosen, the file path can't be specified.
          </div>
        </div>

        {/* Buttons */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            gap: 14,
            marginTop: 30,
          }}
        >
          <Button>Preview</Button>
          <Button type="primary" style={{ background: "#1677ff" }}>
            Save & Print
          </Button>
        </div>
      </Modal>
    </div>
    
  );
};

export default RawMaterial_Planning;
